import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule, ValidatorFn, Validators } from '@angular/forms';
import { ButtonComponent } from 'src/components/button/button.component';
import { InputNumberComponent } from 'src/components/input/input-number.component';
import { InputRadioComponent, InputRadioOption } from 'src/components/input/input-radio.component';
import { InputTextareaComponent } from 'src/components/input/input-textarea.component';
import { Form, FormError } from 'src/definitions/form.definition';
import { CreateKaryawanForm } from 'src/definitions/karyawan.definition';
import { FormService } from 'src/services/form.service';
import { ToastService } from 'src/services/toast.service';
import { GlobalService } from 'src/services/global.service';

export type TanggunganForm = Pick<
  CreateKaryawanForm,
  'martial_status' | 'children_count' | 'living_status' | 'address_current' | 'ownership_status' | 'rent_amount'
> & { has_children: string };

@Component({
  selector: 'step-2',
  templateUrl: './step-2.component.html',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    ButtonComponent,
    InputRadioComponent,
    InputNumberComponent,
    InputTextareaComponent,
  ],
})
export class _Step2Component {
  @Input()
  form!: Form<TanggunganForm>;

  @Input()
  formError!: FormError<TanggunganForm>;

  @Output()
  next = new EventEmitter<void>();

  @Output()
  back = new EventEmitter<void>();

  protected marriageOption: InputRadioOption = [
    { label: 'Kawin', value: 'Kawin' },
    { label: 'Belum Kawin', value: 'Belum Kawin' },
    { label: 'Cerai Hidup', value: 'Cerai Hidup' },
    { label: 'Cerai Mati', value: 'Cerai Mati' },
  ];

  protected hasChildOption: InputRadioOption = [
    { label: 'Ya', value: 'true' },
    { label: 'Tidak', value: 'false' },
  ];

  protected houseTypeOption: InputRadioOption = [
    { label: 'Rumah Pribadi', value: 'Rumah Pribadi' },
    { label: 'Keluarga', value: 'Keluarga' },
    { label: 'Kontrak/Sewa/Kost', value: 'Kontrak/Sewa/Kost' },
  ];

  protected ownershipOption: InputRadioOption = [
    { label: 'Lunas', value: 'Lunas' },
    { label: 'KPR', value: 'KPR' },
  ];

  protected Validators = Validators;

  constructor(
    protected formService: FormService,
    protected toastService: ToastService,
protected globalService: GlobalService,
  ) {}

  protected _onHasChildrenChange(value: string) {
    const childrenCountField = this.form.controls.children_count;

    const validators: ValidatorFn[] = [];
    if (value === 'true') validators.push(Validators.required);

    childrenCountField.setValue(null);
    childrenCountField.setValidators(validators);
    childrenCountField.updateValueAndValidity();

    this.formService.resetError(this.formError, 'has_children');
    this.formService.resetError(this.formError, 'children_count');
  }

  protected _onLivingStatusChange(value: string) {
    const rentAmountField = this.form.controls.rent_amount;
    const ownershipField = this.form.controls.ownership_status;

    const rentValidators: ValidatorFn[] = [];
    const ownershipValidators: ValidatorFn[] = [];
    if (value === 'Kontrak/Sewa/Kost') rentValidators.push(Validators.required);
    if (value === 'Rumah Pribadi') ownershipValidators.push(Validators.required);

    rentAmountField.setValue(null);
    rentAmountField.setValidators(rentValidators);
    rentAmountField.updateValueAndValidity();

    ownershipField.setValue('');
    ownershipField.setValidators(ownershipValidators);
    ownershipField.updateValueAndValidity();

    this.formService.resetError(this.formError, 'living_status');
    this.formService.resetError(this.formError, 'rent_amount');
    this.formService.resetError(this.formError, 'ownership_status');
  }

  protected _next() {
    if (this.form.invalid) {
      const invalid = this.formService.validateAndGetErrorMessage(this.form, this.formError);
      this.toastService.showToast({
        summary: invalid,
        detail: 'Cek ulang isian',
        severity: 'error',
      });
      return;
    }

    this.next.emit();
  }
}
